// Popup shell — generic open/close voor meerdere popups.
// Triggers: [data-popup-open="<popup-id>"]. Sluit: [data-popup-close], backdrop, ESC.
// Focus-management: focus verplaatst naar de dialog bij openen, blijft erin
// gevangen (Tab-trap), en keert terug naar de trigger bij sluiten.

const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function initPopups() {
    const popups = new Map();
    document.querySelectorAll(".popup[id]").forEach((el) => popups.set(el.id, el));
    if (popups.size === 0) return;

    let lastFocused = null;

    const focusables = (popup) =>
        Array.from(popup.querySelectorAll(FOCUSABLE)).filter(
            (el) => el.offsetParent !== null || el === document.activeElement,
        );

    const openPopup = (popup) => {
        lastFocused = document.activeElement;
        popup.hidden = false;
        popup.classList.add("is-open");
        document.body.classList.add("has-popup-open");
        const first = focusables(popup)[0];
        (first || popup).focus();
    };

    const closePopup = (popup) => {
        popup.classList.remove("is-open");
        popup.hidden = true;
        if (!document.querySelector(".popup.is-open")) {
            document.body.classList.remove("has-popup-open");
        }
        if (lastFocused && typeof lastFocused.focus === "function") {
            lastFocused.focus();
            lastFocused = null;
        }
    };

    const closeAll = () => {
        popups.forEach((popup) => {
            if (popup.classList.contains("is-open")) closePopup(popup);
        });
    };

    const trapTab = (popup, e) => {
        if (e.key !== "Tab") return;
        const items = focusables(popup);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    };

    document.querySelectorAll("[data-popup-open]").forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
            const id = trigger.dataset.popupOpen;
            const popup = popups.get(id);
            if (!popup) return;
            e.preventDefault();
            closeAll();
            openPopup(popup);
        });
    });

    popups.forEach((popup) => {
        popup.querySelectorAll("[data-popup-close]").forEach((el) => {
            el.addEventListener("click", () => closePopup(popup));
        });

        popup.addEventListener("click", (e) => {
            if (e.target === popup) closePopup(popup);
        });

        popup.addEventListener("keydown", (e) => trapTab(popup, e));
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeAll();
    });
}
